/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a passkey for faster, more secure authentication`)
};

const zh_hans1_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加通行密钥以获得更快、更安全的身份验证`)
};

const zh_hant1_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增通行金鑰以獲得更快、更安全的身分驗證`)
};

const fr_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une passkey pour une authentification plus rapide et plus sûre`)
};

const de_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge einen Passkey hinzu – schneller und sicherer authentifizieren`)
};

const ja_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを追加して、より速く安全に認証しましょう`)
};

const ko_settings_add_passkey_promo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 빠르고 안전한 인증을 위해 패스키를 추가하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_add_passkey_promo = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_add_passkey_promo(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_add_passkey_promo", locale)
	if (locale === "en") return en_settings_add_passkey_promo(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_add_passkey_promo(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_add_passkey_promo(inputs)
	if (locale === "fr") return fr_settings_add_passkey_promo(inputs)
	if (locale === "de") return de_settings_add_passkey_promo(inputs)
	if (locale === "ja") return ja_settings_add_passkey_promo(inputs)
	return ko_settings_add_passkey_promo(inputs)
};